import React from "react";

export function Section({ children, className = "", id, testId }) {
  return (
    <section id={id} data-testid={testId} className={`py-20 md:py-28 ${className}`}>
      {children}
    </section>
  );
}

export function Container({ children, className = "" }) {
  return (
    <div className={`max-w-7xl mx-auto px-6 md:px-12 ${className}`}>
      {children}
    </div>
  );
}

export function Overline({ children, className = "" }) {
  return (
    <div className={`overline text-[#946f36] ${className}`}>
      <span className="gold-rule mr-3" /> {children}
    </div>
  );
}

export function PageHero({ overline, title, subtitle, testId }) {
  return (
    <section
      data-testid={testId}
      className="relative bg-[#281a12] text-[#FDFBF7] grain overflow-hidden"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-24 md:py-32 relative z-10">
        {overline && (
          <div className="overline text-[#946f36] mb-6">
            <span className="gold-rule mr-3 bg-[#946f36]" /> {overline}
          </div>
        )}
        <h1 className="font-serif-display text-5xl md:text-7xl font-light tracking-tight leading-[1.05] max-w-4xl">
          {title}
        </h1>
        {subtitle && (
          <p className="mt-6 text-[#D1C3B4] text-lg max-w-2xl leading-relaxed">
            {subtitle}
          </p>
        )}
      </div>
    </section>
  );
}
